<div class="ag-grid ag-theme-balham" [style.height]="height ? height + 'px' : 'auto'" #grid>
</div>